




















import { Component, Prop, Vue } from 'vue-property-decorator'
import { SolutionFile } from '@/models'
import Prism from 'vue-prism-component'


@Component({
  components: {
    Prism
  }
})
export default class Solution extends Vue {
  @Prop() private solutionFile!: SolutionFile

  private get markdown(): string {
    return this.solutionFile.solution.codeMarkdown
  }
}
